import Typography from '@mui/material/Typography';
import {
  Box,
  Chip,
  Paper,
} from '@mui/material';
import { dateFormat } from '../../../shared/helpers/dateFormat';
import React from 'react';
import { useAppThemeContext } from '../../../shared/contexts';
import { IAppointmentView } from '../../../shared/services';

interface IProps {
  children?: React.ReactNode;
  appointment: IAppointmentView;
  disabled: boolean;
  colorDisabled: string;
}

const InfoBox: React.FC<{ appointment: IAppointmentView; disabled: boolean; colorDisabled: string }> = ({ appointment, disabled, colorDisabled }) => (
  <Box>
    <Typography color={disabled ? colorDisabled : 'none'} variant='h6'>
      {appointment.businessName}
    </Typography>
    <Typography color={disabled ? colorDisabled : 'none'}>
      {`${appointment.services.map(x => x.description).join(' - ')} - ${appointment.employeeName}`}
    </Typography>
    <Typography color={disabled ? colorDisabled : 'none'}>
      {dateFormat(appointment.date, 'LLL')}
    </Typography>
    <Typography color={disabled ? colorDisabled : 'none'}>
      {appointment.businessAddress}
    </Typography>

    {appointment.canceled && (
      <Box mt={1}>
        {appointment.cancelReason && (
          <Typography variant='body2' color='error.main' sx={{ fontStyle: 'italic' }}>
            Motivo: {appointment.cancelReason}
          </Typography>
        )}
        {appointment.canceledAt && (
          <Typography variant='body2' color='text.secondary'>
            Cancelado em: {dateFormat(new Date(appointment.canceledAt), 'L [às] HH:mm')}
          </Typography>
        )}
      </Box>
    )}
  </Box>
);

export const HomeAppointmentsPage: React.FC<IProps> = ({ children, appointment, disabled, colorDisabled }) => {
  const { isTablet: isMobile } = useAppThemeContext();

  return (
    <>
      <Box key={appointment.id} display='flex' flexDirection='column' gap={2} data-testid={`appointment-card-${appointment.id}`}>
        <Paper
          variant='outlined'
          sx={{ padding: 1, lightingColor: 'secondary' }}
        >
          {isMobile ? (
            <Box display='flex' flexDirection='column' gap={1.5} padding={1} textAlign='center'>
              <InfoBox appointment={appointment} disabled={disabled} colorDisabled={colorDisabled} />

              {!disabled && appointment.status === 1 && (
                <Box display='flex' justifyContent='center'>
                  <Chip label="Pendente confirmação" color="warning" />
                </Box>
              )}

              {children && (
                <Box display='flex' justifyContent='center'>
                  {children}
                </Box>
              )}
            </Box>
          ) : (
            <Box
              display='grid'
              gridTemplateColumns={
                !disabled && appointment.status === 1
                  ? '1fr auto auto'
                  : '1fr auto'
              }
              alignItems='center'
              gap={2}
              px={2}
            >
              <InfoBox appointment={appointment} disabled={disabled} colorDisabled={colorDisabled} />

              {!disabled && appointment.status === 1 && (
                <Box display='flex' justifyContent='center'>
                  <Chip label="Pendente confirmação" color="warning" />
                </Box>
              )}

              {children && (
                <Box display='flex' justifyContent='flex-end'>
                  {children}
                </Box>
              )}
            </Box>
          )}
        </Paper>
      </Box>
    </>
  );
};
